(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikegger-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.hiwInit) return;
    root.dataset.hiwInit = '1';

    // Pour demo (scoped per section)
    var btn = root.querySelector('.js-pour');
    if(btn){
      var demo   = root.querySelector('.demo');
      var liquid = root.querySelector('.js-liquid');
      var foam   = root.querySelector('.js-foam');
      var hint   = root.querySelector('.js-hint');
      var reset  = root.querySelector('.js-reset');
      var level = 0, pouring = false, raf = null, SPEED = 0.9; // slower pour

      function render(){
        var foamH = Math.min(14, level*0.15);
        liquid.style.height = level + '%';
        foam.style.height = (level>1 ? foamH : 0) + '%';
        foam.style.bottom = level + '%';
      }
      function tick(){
        if(!pouring) return;
        if(level < 100){ level = Math.min(100, level + SPEED); render(); raf = requestAnimationFrame(tick); }
        else { stop(true); }
      }
      function start(e){
        if(e && e.preventDefault) e.preventDefault();
        if(level >= 100) return;
        pouring = true; if(demo) demo.classList.add('is-pouring');
        hint.textContent = 'Pouring…'; raf = requestAnimationFrame(tick);
      }
      function stop(full){
        pouring = false; if(raf) cancelAnimationFrame(raf);
        if(demo) demo.classList.remove('is-pouring');
        if(full || level >= 100){ hint.textContent = 'Perfect pour. That easy.'; reset.hidden = false; btn.disabled = true; btn.style.opacity = '.5'; }
        else if(level > 0){ hint.textContent = 'Keep holding to fill it up'; reset.hidden = false; }
        else { hint.textContent = 'Hold it down — let go to stop'; }
      }
      btn.addEventListener('pointerdown', start);
      window.addEventListener('pointerup', function(){ if(pouring) stop(false); });
      btn.addEventListener('pointercancel', function(){ if(pouring) stop(false); });
      btn.addEventListener('keydown', function(e){ if((e.key===' '||e.key==='Enter') && !pouring){ e.preventDefault(); start(); }});
      btn.addEventListener('keyup', function(e){ if(e.key===' '||e.key==='Enter'){ stop(false); }});
      reset.addEventListener('click', function(){ level = 0; render(); reset.hidden = true; btn.disabled = false; btn.style.opacity = '1'; hint.textContent = 'Hold it down — let go to stop'; });
      render();
    }

    // Scroll reveal
    var els = root.querySelectorAll('.hiw-reveal');
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }});
      }, {threshold:.14});
      els.forEach(function(el){ io.observe(el); });
    } else {
      els.forEach(function(el){ el.classList.add('in'); });
    }
  }
  function boot(){ document.querySelectorAll('.ikegger-hiw').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  // Re-init when added/edited in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikegger-our-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.stInit) return; root.dataset.stInit='1';
    var els = root.querySelectorAll('.st-reveal');
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
      els.forEach(function(el){io.observe(el);});
    } else { els.forEach(function(el){el.classList.add('in');}); }
  }
  function boot(){ document.querySelectorAll('.ikegger-story').forEach(init); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikegger-pdp"]) return;
  try {
    
(function(){
  function main(){ return document.querySelector('[id^="MainProduct-"]'); }
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-ikx-top]'); if (!a) return;
    var m = main(); if (!m) return; e.preventDefault();
    var t = m.querySelector('.product-form__input, variant-selects, .ikx-pk') || m;
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  function initSticky(){
    var bar = document.querySelector('[data-ikx-sticky]'); var m0 = main(); if (!bar || !m0 || bar.dataset.ready) return;
    var add = m0.querySelector('button[name="add"]'); if (!add) return; bar.dataset.ready = '1';
    var priceEl = bar.querySelector('[data-ikx-sticky-price]'); var btn = bar.querySelector('[data-ikx-sticky-btn]');
    function sync(){
      var m = main(); var p = m && m.querySelector('.price .price-item--sale, .price .price-item--regular');
      if (p) priceEl.textContent = p.textContent.trim();
      btn.disabled = add.disabled; btn.textContent = add.disabled ? 'Sold out' : 'Add to cart';
    }
    var io = new IntersectionObserver(function(en){ var vis = en[0].isIntersecting || en[0].boundingClientRect.top > 0; bar.hidden = vis; if (!vis) sync(); });
    io.observe(add);
    btn.addEventListener('click', function(){ sync(); if (!add.disabled) add.click(); });
    setInterval(function(){ if (!bar.hidden) sync(); }, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();

  } catch(e) { console.error(e); }
})();
})();
